<template>
    <div>
        <div class="menu-mobile" v-if="isVisible">
            <div class="d-flex justify-content-between text-center">
                <div v-for="item in menu" :key="item.name" @click="verifyItem(item)" class="mt-1 flex-fill">
                    <b-button variant="link" :to="item.link" class="px-1">
                        <div class="position-relative">
                            <b-icon :icon="item.icon" class="item-icon" :class="{'menu-mobile-active-icon': isEqual(item.value)}"></b-icon>
                            <div v-if="item.value == 'cart' && $store.state.order.order.quantidade_total > 0" class="menu-mobile-items-cart">
                                {{ $store.state.order.order.quantidade_total }}
                            </div>
                        </div>
                        <div class="item-name" :class="{'active': isEqual(item.value)}">
                            {{ item.name }}
                        </div>
                    </b-button>
                </div>
            </div>
        </div>
        <div class="openned-menu" v-if="active_menu === 'categories'">
            <div class="openned-menu-title">
                Categorias
            </div>
            <div>
                <CategoriesMobile/>
            </div>
        </div>
        <transition :name="$wdconfig.modules.general.layout_mode === 'website' ? 'slide' : ''">
            <div class="openned-menu" :class="{'pb-0': $wdconfig.modules.general.layout_mode === 'website'}" v-if="active_menu === 'menu'" @touchstart="touchStart" @touchend="touchEnd">
                <div class="openned-menu-title d-flex align-items-center" style="font-size: 14px; line-height: 1.35;">
                    <span v-if="$wdconfig.modules.general.layout_mode !== 'website'">Menu</span>
                    <template v-else>
                        <a :href="$store.state.auth.person_name ? '/conta/mxeus-dados/' : '/login'" class="d-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 28.328 28.328" class="mr-2">
                                <path class="a" d="M28.328,14.164A14.164,14.164,0,1,0,14.164,28.328,14.156,14.156,0,0,0,28.328,14.164ZM14.164,1.66a12.506,12.506,0,0,1,10.363,19.5,14.158,14.158,0,0,0-20.725,0A12.506,12.506,0,0,1,14.164,1.66ZM4.836,22.49a12.5,12.5,0,0,1,18.655,0A12.492,12.492,0,0,1,4.836,22.49Zm0,0"/>
                                <path class="a" d="M170.979,72.619a4.985,4.985,0,0,0,4.979-4.979v-1.66a4.979,4.979,0,1,0-9.959,0v1.66A4.985,4.985,0,0,0,170.979,72.619Zm-3.32-6.639a3.32,3.32,0,1,1,6.639,0v1.66a3.32,3.32,0,1,1-6.639,0Zm0,0" transform="translate(-156.816 -57.625)"/>
                            </svg>
                            <div v-if="$store.state.auth.person_name">
                                <b class="d-block">Olá, {{ $store.state.auth.person_name }}</b>
                                Minha conta
                            </div>
                            <div v-else>
                                Entre ou cadastre-se
                            </div>
                        </a>
                        <button type="button" aria-label="Close" class="close" @click="close">×</button>
                    </template>
                </div>
                <div>
                    <MenuMobile/>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div class="openned-menu-backdrop" @click="close" v-if="active_menu && $wdconfig.modules.general.layout_mode === 'website'"></div>
        </transition>
    </div>
</template>
<script>
    import CategoriesMobile from "~/components/CategoriesMobile";
    import MenuMobile from "~/components/MenuMobile/MenuMobile";

    export default {
        components: {
            CategoriesMobile,
            MenuMobile
        },
        data() {
            return {
                menu: [
                    {
                        name: 'Home',
                        icon: 'house-fill',
                        value: 'home',
                        link: '/',
                        overlay: false
                    },
                    {
                        name: 'Categorias',
                        icon: 'list-ul',
                        value: 'categories',
                        overlay: true
                    },
                    {
                        name: 'Minha conta',
                        icon: 'person-circle',
                        value: 'account',
                        link: '/conta/meus-dados/',
                        overlay: false
                    },
                    {
                        name: 'Carrinho',
                        icon: 'cart',
                        value: 'cart',
                        link: '/carrinho',
                        overlay: false
                    },
                    {
                        name: 'Menu',
                        icon: 'list',
                        value: 'menu',
                        overlay: true
                    },
                ],
                active_menu: '',
                overlay: false
            }
        },
        mounted() {
            this.$nuxt.$on("openMenuMobile", () => {
                this.active_menu = 'menu'
                this.overlay = true
                document.body.classList.add('mobile-openned-menu')
            });
        },
        methods: {
            verifyItem(item) {
                if (this.active_menu === item.value) {
                    this.active_menu = ''
                    this.overlay = false
                } else {
                    this.active_menu = item.value
                    this.overlay = item.overlay
                }
            },
            isEqual(item) {
                return this.active_menu === item
            },
            close() {
                this.active_menu = ''
                this.overlay = false
                document.body.classList.remove('mobile-openned-menu')
            },
            touchStart(e) {
                this.touchX = e.changedTouches[0].clientX;
            },
            touchEnd(e) {
                const deltaX = e.changedTouches[0].clientX - this.touchX;
                if (deltaX < -50) {
                    this.close();
                }
            }
        },
        computed: {
          isVisible() {
              if (this.$wdconfig.modules.general.layout_mode === 'website') {
                  return false
              }
              if (this.$route.path.indexOf('/produto/') === 0 || this.$route.path === '/carrinho' ||  this.$route.path === '/checkout') {
                  return false
              }
              return true
            }
        },
        watch: {
            $route(newvalue) {
                this.active_menu = ''
                this.overlay = false
            }
        }
    }
</script>
